<template>
  <media-radio
    class="ring-media-focus group relative flex w-full cursor-pointer select-none items-center justify-start rounded-sm p-2.5 outline-none data-[hocus]:bg-white/10 data-[focus]:ring-[3px]"
  >
    <svg class="h-4 w-4 text-white group-data-[checked]:hidden" width="32" height="32" viewBox="0 0 32 32" fill="none"
         xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd"
            d="M16 26.6667C21.891 26.6667 26.6666 21.891 26.6666 16C26.6666 10.109 21.891 5.33334 16 5.33334C10.1089 5.33334 5.33331 10.109 5.33331 16C5.33331 21.891 10.1089 26.6667 16 26.6667ZM16 23.3333C20.0501 23.3333 23.3333 20.0501 23.3333 16C23.3333 11.9499 20.0501 8.66668 16 8.66668C11.9499 8.66668 8.66665 11.9499 8.66665 16C8.66665 20.0501 11.9499 23.3333 16 23.3333Z"
            fill="currentColor"/>
    </svg>
    <svg class="text-media-brand hidden h-4 w-4 group-data-[checked]:block" width="32" height="32" viewBox="0 0 32 32"
         fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16 20.6667C18.5773 20.6667 20.6666 18.5773 20.6666 16C20.6666 13.4227 18.5773 11.3333 16 11.3333C13.4227 11.3333 11.3333 13.4227 11.3333 16C11.3333 18.5773 13.4227 20.6667 16 20.6667Z"
        fill="currentColor"/>
      <path fill-rule="evenodd" clip-rule="evenodd"
            d="M26.6666 16C26.6666 21.891 21.891 26.6667 16 26.6667C10.1089 26.6667 5.33331 21.891 5.33331 16C5.33331 10.109 10.1089 5.33334 16 5.33334C21.891 5.33334 26.6666 10.109 26.6666 16ZM24 16C24 20.4183 20.4183 24 16 24C11.5817 24 7.99998 20.4183 7.99998 16C7.99998 11.5817 11.5817 8.00001 16 8.00001C20.4183 8.00001 24 11.5817 24 16Z"
            fill="currentColor"/>
    </svg>
    <span class="ml-2" data-part="label"></span>
  </media-radio>
</template>
